import React from 'react';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var BadgeOverlap = createEnum(['space-1x', 'space-3o4', 'space-1o2', 'space-1o4']);
var BadgeType = createEnum(['default', 'subtle', 'confirm', 'warn', 'primary']);
var BadgeSize = createEnum(['inherit', 'jumbo', 'display', 'h1', 'h2', 'h3', 'intro', 'h4', 'h5', 'body_large', 'body', 'base', 'caption', 'h6', 'meta', 'eyebrow', 'eyebrow-emphasis']);
var bool = PT.bool,
  oneOf = PT.oneOf,
  string = PT.string;
var defaults = {
  className: "",
  id: null,
  isNotificationDot: false,
  label: "",
  overlap: null,
  size: BadgeSize.INHERIT,
  type: BadgeType.DEFAULT
};
var Badge = function Badge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    content = _ref.content,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$isNotificationDo = _ref.isNotificationDot,
    isNotificationDot = _ref$isNotificationDo === void 0 ? defaults.isNotificationDot : _ref$isNotificationDo,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? defaults.label : _ref$label,
    _ref$overlap = _ref.overlap,
    overlap = _ref$overlap === void 0 ? defaults.overlap : _ref$overlap,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaults.size : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaults.type : _ref$type;
  if (type === "subtile") {
    console.warn("'subtile' is a typo which has been deprecated, use 'subtle' instead");
  }
  var classes = classnames("badge", "c-els-badge", className, {
    // DEPRECATED: 'subtile' is an old typo
    "c-els-badge--background-subtle": type === BadgeType.SUBTLE || type === "subtile",
    "c-els-badge--background-confirm": type === BadgeType.CONFIRM,
    "c-els-badge--background-warn": type === BadgeType.WARN,
    "c-els-badge--background-primary": type === BadgeType.PRIMARY,
    "c-els-badge--size-jumbo": size === BadgeSize.JUMBO,
    "c-els-badge--size-display": size === BadgeSize.DISPLAY,
    "c-els-badge--size-h1": size === BadgeSize.H1,
    "c-els-badge--size-h2": size === BadgeSize.H2,
    "c-els-badge--size-h3": size === BadgeSize.H3,
    "c-els-badge--size-intro": size === BadgeSize.INTRO,
    "c-els-badge--size-h4": size === BadgeSize.H4,
    "c-els-badge--size-h5": size === BadgeSize.H5,
    "c-els-badge--size-body-large": size === BadgeSize.BODY_LARGE,
    "c-els-badge--size-body": size === BadgeSize.BODY,
    "c-els-badge--size-base": size === BadgeSize.BASE,
    "c-els-badge--size-caption": size === BadgeSize.CAPTION,
    "c-els-badge--size-h6": size === BadgeSize.H6,
    "c-els-badge--size-meta": size === BadgeSize.META,
    "c-els-badge--size-eyebrow": size === BadgeSize.EYEBROW,
    "c-els-badge--overlap-1x": overlap === BadgeOverlap.SPACE_1X,
    "c-els-badge--overlap-3o4": overlap === BadgeOverlap.SPACE_3O4,
    "c-els-badge--overlap-1o2": overlap === BadgeOverlap.SPACE_1O2,
    "c-els-badge--overlap-1o4": overlap === BadgeOverlap.SPACE_1O4,
    "c-els-badge--notification-dot": isNotificationDot
  });
  return /* @__PURE__ */React.createElement("span", {
    className: classes,
    id: id,
    "data-testid": "badge"
  }, !isNotificationDot && content, isNotificationDot && /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually",
    "data-testid": "badge-hidden-content"
  }, content), label && /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, " ", label));
};
Badge.propTypes = {
  /** class name to view different color of badges */
  className: string,
  /** to display content in badge */
  content: string.isRequired,
  /** ID for the Banner */
  id: string,
  /** Only show a notification dot */
  isNotificationDot: bool,
  /** Additional, visually hidden, content */
  label: string,
  /** position badge to overlap the preceding contents */
  overlap: oneOf(BadgeOverlap.getAll()),
  /** change size of badge based on els-styleguide-badge modifiers */
  size: oneOf(BadgeSize.getAll()),
  /** Use of badge by styleguide, subtile supported but deprecated */
  // Subtile manually added while it's still deprecated rather than unsupported
  type: oneOf(BadgeType.getAll().concat(["subtile"]))
};
Badge.requiredProps = {
  content: ValidPropTypes.STRING
};
Badge.Types = BadgeType;
Badge.Sizes = BadgeSize;
Badge.Overlaps = BadgeOverlap;
Badge.defaults = defaults;
var RawBadge = Badge;
var Badge$1 = makeErrorBoundComponent(RawBadge);
export { Badge$1 as Badge, RawBadge };
